import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import {confirmAlert} from "react-confirm-alert";
import LoadingSplash from "../../globalComponents/LoadingSplash";

class LocationOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany : null,
            currentCompanyLocations: null,
            filteredCompanyLocations: null,
        };

        this.translate = this.props.baseData.translate;

        this.requestCompanyLocations = this.requestCompanyLocations.bind(this);
        this.locationDelete = this.locationDelete.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentDidMount() {

        this.requestCompanyLocations();

    }

    requestCompanyLocations() {

        if (this.state.currentCompany === null) {
            return;
        }

        const params = {
            companyId: this.state.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyLocations: res,
                    filteredCompanyLocations: res,
                });
            }
        }.bind(this);

        this.api.request('GetCompanyLocations', params, callback);

    }

    locationDelete(location) {

        if (!this.props.baseData.companies || !this.props.baseData.companies.currentCompany) {
            return;
        }

        const params = {
            action: 'deleteCompanyLocation',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            id: parseInt(location.id),
            companyId: parseInt(location.id_company),
            name: location.name,
            machineCount: parseInt(location.machine_count),
        };

        if (params.machineCount !== 0) {
            alert(this.translate('locationStillContainsMachines'));
        } else {
            confirmAlert({
                title: this.translate('deleteLocation'),
                message: this.translate('deleteLocationQuestion') + ' "' + params.name + '" ',
                buttons: [
                    {
                        label: this.translate('yes'),
                        onClick: () => {
                            const callback = function (res) {
                                if (res.success) {
                                    alert(this.translate(res.msgKey));

                                    this.requestCompanyLocations();
                                }
                            }.bind(this);

                            this.api.request('AdminFunctions', params, callback);
                        }
                    },
                    {
                        label: this.translate('no'),
                    }
                ]
            });
        }

    }

    onSearch(name, value) {

        const tableData = this.getTableData();
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredCompanyLocations: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyLocations: this.getTableData(this.state.currentCompanyLocations),
        });

    }

    locationEdit(location) {

        this.changeView('edit', location);

    }

    changeView(view, location = null) {

        if (this.props.changeView) this.props.changeView(view, location);

    }

    getTableData() {

        const rawData = this.state.currentCompanyLocations;

        return rawData.map((data) => {
            return {
                id: data.id,
                company_id: data.id_company,
                company_name: data.company_name + ' (' + data.id_company + ')',
                name: data.name,
                machine_count: data.machine_count
            };
        });

    }

    getCompanyUserColumns() {

        const columns = [];

        if (this.props.baseData.checkUserRole('superadmin')) {
            columns.push({
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            });
        }

        columns.push(
            {
                key: 'company',
                nameKey: 'company',
                sortType: 'string',
            },
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'machineCounter',
                nameKey: 'machines',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'options',
                nameKey: 'options',
            }
        );

        return columns;

    }

    getCompanyUserRows() {

        const tableData = (this.state.filteredCompanyLocations) ? this.state.filteredCompanyLocations : [];

        return tableData.map(
            (data) => {
                return {
                    id: data.id,
                    company: data.company_name,
                    location: data.name,
                    machineCounter: data.machine_count,
                    options: <div className="tableOptions">
                        <a className="optionEdit" onClick={() => this.locationEdit(data)} title={this.translate('edit')}>&nbsp;</a>
                        <a className="optionDelete" onClick={() => this.locationDelete(data)} title={this.translate('delete')}>&nbsp;</a>
                    </div>
                }
            }
        );

    }

    render() {

        if (!this.state.currentCompanyLocations) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredCompanyLocations) ? this.state.filteredCompanyLocations.length : 0;
        const countText = (dataCount === 1) ? this.translate('location') : this.translate('locations');
        const locationColumns = this.getCompanyUserColumns();
        const locationRows = this.getCompanyUserRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectLocation')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchLocationOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>

                        <div className="flr">
                            <div className="bottomLinks">
                                <a className="prewLink" onClick={(e) => this.changeView('add')}>{this.translate('addNewLocation')}</a>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={locationColumns}
                            rows={locationRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default LocationOverviewContainer;